






























































import { Component, Model, Vue } from "vue-property-decorator";
import { NotifFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    DatePicker
  }
})
export default class NotifSearch extends Vue {
  @Model("change") readonly filter!: NotifFilter;
}
